import type {ChannelCategory} from '@mattermost/types/channel_categories';
import {ChannelCategoryType} from '../constants';

export function isDirectMessagesChannelCategory(category: ChannelCategory) {
    return category?.type === ChannelCategoryType.DIRECT_MESSAGES;
}
